document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-legswell-reviews-track]').forEach(function (track) {
    var isDown = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('pointerdown', function (e) {
      // Touch input already gets native swipe/scroll/snap from the CSS
      // (overflow-x + scroll-snap); this drag handler is only for mouse,
      // since a mouse has no native way to "swipe" a scroll container.
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      track.setPointerCapture(e.pointerId);
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('cls-legswell-reviews__track--dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = scrollStart - (e.clientX - startX);
    });

    function endDrag() {
      isDown = false;
      track.classList.remove('cls-legswell-reviews__track--dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
  });
});
